import { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import Avatar from "@/components/Avatar";
import Logo from "@/components/Logo";
import ProfilePic from "@/components/ProfilePic";
import NavIcon from "@/components/NavIcon";
import Footer from "@/components/Footer";
import Lottie from "lottie-react";
import { useLoading } from "@/hooks/useLoading";
import LoadingScreen from "@/components/ui/LoadingScreen";
import ChatBot from "@/components/ChatBot";


// Navigation icons with SVG icons
const navigationIcons = [
  {
    icon: "/bucket/icons/about.svg",
    label: "À propos",
    path: "/about",
  },
  {
    icon: "/bucket/icons/skills.svg",
    label: "Skills", 
    path: "/skills",
  },
  {
    icon: "/bucket/icons/portfolio.svg",
    label: "Projets",
    path: "/projects",
  },
  {
    icon: "/bucket/icons/resume.svg",
    label: "Parcours",
    path: "/resume",
  },
  { 
    icon: "/bucket/icons/blog.svg", 
    label: "Blog", 
    path: "/blog" 
  },
  {
    icon: "/bucket/icons/network.svg",
    label: "Réseau",
    path: "/testimonials",
  },
  {
    icon: "/bucket/icons/events.svg",
    label: "Evenements",
    path: "/services",
  },
  {
    icon: "/bucket/icons/contact.svg",
    label: "Contact",
    path: "/contact",
  },
  {
    icon: "/bucket/icons/docs.svg",
    label: "Documents",
    path: "/playground",
  },
];

const Index = () => {
  const { loading } = useLoading({ duration: 1000 });

  if (loading) {
    return <LoadingScreen />;
  }

  return (
    <>
      <Helmet>
        <title>Mopaossi | Développeur Créatif</title>
        <meta
          name="description"
          content="Développeur Frontend | No-code| Low-code | UI/UX | Agilité"
        />
        <meta property="og:title" content="Mopaossi | Développeur Créatif" />
        <meta
          property="og:description"
          content="Découvrer un créateur, digitalisation, tech, app, dev : Mes sujets préférés."
        />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="https://hynmctzoemxttjsmvjyz.supabase.co/storage/v1/object/public/images//sp.png" />
        <link rel="canonical" href="https://cbenji.pages.dev" />
      </Helmet>

      <main className="min-h-screen w-screen overflow-hidden gradient-bg flex flex-col lg:flex-row p-4 lg:p-8">
        {/* Left column - Avatar section */}
        <section className="w-full lg:w-1/2 flex items-center justify-center p-4 lg:p-8">
          <div className=" w-full h-full  p-4 flex items-center justify-center">
            <Avatar
              src="https://hynmctzoemxttjsmvjyz.supabase.co/storage/v1/object/public/images//sp.png"
              alt="Mopaossi Avatar"
              className="w-full h-full"
            />
          </div>
        </section>

        {/* Right column - Content section */}
        <section className="w-full lg:w-1/2 flex flex-col p-4 lg:p-8">
          {/* Header with logo and profile pic */}
          <div className="flex items-center justify-between mb-8">
            <Logo />
          </div>

          {/* Welcome heading */}
          <div className="mb-12">
            <h1 className="text-4xl lg:text-5xl xl:text-6xl font-bold mb-2">
              Bonjour je suis{" "}
              <span className="text-4xl md:text-5xl font-bold mb-2 lg:text-5xl xl:text-6xl  bg-clip-text text-transparent bg-gradient-to-r from-blue-500 via-purple-500 to-blue-500 animate-gradient">
                Dev.
              </span>
            </h1>
            <p className="text-lg text-gray-600">
            Software Developer | Automation | IT Support.
            </p>
          </div>

          {/* Navigation icons grid */}
          <div className="grid grid-cols-3 gap-6">
            {navigationIcons.map((icon, index) => (
              <NavIcon
                key={index}
                icon={icon.icon}
                label={icon.label}
                to={icon.path}
                isLottie={false}
              />
            ))}
          </div>
        </section>
      </main>
      <Footer />
       <ChatBot />
    </>
  );
};

export default Index;
